import React, { useEffect } from 'react';
import styles from './Modal.module.css';
import CloseButton from '../closeButton';
import SubmitButton from '../submitButton';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import { noScroll, removeNoScroll } from '@/actions/Helper';

const Modal = ({
  show,
  setShow,
  submit,
  submitText,
  children,
  icon,
  description,
  title,
  loadingbutton,
  notClose = false,
  rightContent = null,
  noX = false,
  minWidth = 600,
  titleColor,
  customHandleClose,
  buttonPosition = 'center',
  maxHeight = null,
}) => {
  const handleClose = () => {
    setShow(false);
    removeNoScroll();
    if (customHandleClose) {
      customHandleClose();
    }
  };
  useEffect(() => {
    if (show) {
      noScroll();
    }
    if (!show) {
      removeNoScroll();
    }
  }, [show]);
  const backdropClick = (e) => {
    if (notClose) {
      e.stopPropagation();
      e.preventDefault();
    } else {
      handleClose();
    }
  };
  if (!show) return null;

  return (
    <div className={styles.backdrop} onClick={(e) => backdropClick(e)}>
      <div
        className={styles.modal}
        style={{
          minWidth,
        }}
        onClick={(e) => e.stopPropagation()}>
        {!noX && (
          <div
            onClick={(e) => handleClose(e)}
            style={{ width: '100%', position: 'relative' }}>
            <ReactSVG src={Icons.close} className={styles.closePx} />
          </div>
        )}

        <div className={styles.header}>
          <div className={styles.headerTitle}>
            <div className={styles.innerHeader}>
              <ReactSVG
                src={Icons[icon]}
                className={styles.icon}
                beforeInjection={(svg) => {
                  svg.querySelectorAll('path').forEach((path) => {
                    path.setAttribute(
                      'stroke',
                      titleColor
                        ? titleColor
                        : submitText
                        ? '#FB3748'
                        : '#131517'
                    );
                  });
                }}
              />
              <span
                style={{
                  color: titleColor
                    ? titleColor
                    : submitText
                    ? '#FB3748'
                    : '#131517',
                }}>
                {title}
              </span>
            </div>
            {rightContent && rightContent}
          </div>
        </div>
        {description && <div className={styles.description}>{description}</div>}
        <div
          className={styles.childContainer}
          style={
            maxHeight
              ? {
                  maxHeight,
                }
              : {}
          }>
          {children}
        </div>
        {submitText && (
          <div
            className={styles.modalButtons}
            style={{
              justifyContent: buttonPosition,
            }}>
            <CloseButton onClick={handleClose} text={'No, later'} />
            <SubmitButton
              text={submitText}
              onClick={submit}
              disable={false}
              loading={loadingbutton}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
